// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"33":"771d9255","82":"634e5ed7","355":"b9313095","534":"fe740a8f","778":"ae8c49bc"}[chunkId] + ".chunk.css";
};